export default function Footer() {
  return (
    <footer className="bg-stone-100 border-t border-stone-200 mt-16">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {/* Company */}
          <div>
            <h5 className="text-xs font-bold text-gray-900 uppercase tracking-widest mb-4">
              PROFI-NIERUCHOMOŚCI
            </h5>
            <div className="space-y-2">
              <p className="flex items-start gap-2 text-sm text-gray-600">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-2-line text-amber-600 text-base" />
                </span>
                ul. Juliana Tuwima 23/2
              </p>
              <p className="flex items-start gap-2 text-sm text-gray-600">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-2-line text-transparent text-base" />
                </span>
                76-200 Słupsk
              </p>
            </div>
          </div>

          {/* Phone */}
          <div>
            <h5 className="text-xs font-bold text-gray-900 uppercase tracking-widest mb-4">
              Telefon kontaktowy
            </h5>
            <div className="space-y-2">
              <a
                href="tel:723178962"
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-amber-700 cursor-pointer transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-amber-600 text-base" />
                </span>
                723 178 962
              </a>
              <a
                href="tel:513915464"
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-amber-700 cursor-pointer transition-colors"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-amber-600 text-base" />
                </span>
                513 915 464
              </a>
            </div>
          </div>

          {/* Email */}
          <div>
            <h5 className="text-xs font-bold text-gray-900 uppercase tracking-widest mb-4">
              E-mail
            </h5>
            <a
              href="mailto:biuro@profikredyt.com.pl"
              className="flex items-center gap-2 text-sm text-gray-600 hover:text-amber-700 cursor-pointer transition-colors"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-amber-600 text-base" />
              </span>
              biuro@profikredyt.com.pl
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} PROFI-NIERUCHOMOŚCI. Wszelkie prawa zastrzeżone.
          </p>
          <a
            href="http://www.nieruchomosci-pomorze.pl/polityka-prywatnosci"
            rel="nofollow noopener"
            target="_blank"
            className="text-xs text-gray-400 hover:text-amber-600 cursor-pointer transition-colors whitespace-nowrap"
          >
            Polityka prywatności
          </a>
        </div>
      </div>
    </footer>
  );
}
